<template>
  <DragDialog
    class="inner-pop-primary"
    title="删除分组"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['submit', 'cancel']"
    :submit="submit"
    :cancel="closeDialog"
  >
    <div class="delete-group-box">
      <el-radio-group
        class="radio-primary"
        v-model="isMigrationGroup"
        @input="handleRadioGroupChange"
      >
        <div class="radio-box">
          <el-radio :label="false">删除分组</el-radio>
        </div>
        <div class="radio-box">
          <el-radio :label="true">迁移锚点并删除分组</el-radio>
        </div>
      </el-radio-group>
      <div v-if="isMigrationGroup" class="migration-group-box">
        <div class="label-box">目标分组：</div>
        <el-select
          class="primary-select"
          size="small"
          v-model="targetGroupId"
          placeholder="请选择目标分组"
        >
          <el-option
            v-for="(item, index) in groupList"
            :key="index"
            :label="item.groupName"
            :value="item.groupId"
          />
        </el-select>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";

import {
  getSceneAnchorGroupListService,
  deleteSceneAnchorGroupService,
} from "@/service/interface";

export default {
  data() {
    return {
      isMigrationGroup: false,
      targetGroupId: undefined,

      groupList: [],
    };
  },
  props: {
    visible: Boolean,
    groupIdToDelete: String,
    refreshAnchorList: Function,
  },
  components: { DragDialog },
  methods: {
    handleRadioGroupChange(value) {
      if (value) {
        this.initGroupList();
      }
    },
    initGroupList() {
      if (this.groupList.length) return;

      let sceneId = this.$route.query.sceneId;
      getSceneAnchorGroupListService(sceneId).then((response) => {
        if (response.isSuccess) {
          let groupList = response.data;
          groupList = groupList.filter(
            (item) => item.groupId !== this.groupIdToDelete
          );
          this.groupList = groupList;
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    submit() {
      let params = {
        groupId: this.groupIdToDelete,
        moveToGroupId: this.targetGroupId,
      };
      deleteSceneAnchorGroupService(params).then((response) => {
        if (response.isSuccess) {
          let isMigrationGroup = this.isMigrationGroup;
          let originGroupId = this.groupIdToDelete;
          let targetGroupId = this.targetGroupId;
          // prettier-ignore
          this.$emit("reRnderAnchor", isMigrationGroup, originGroupId, targetGroupId);
          this.refreshAnchorList().then(() => {
            this.closeDialog();
            this.$message.success("删除成功！");
          });
        } else {
          this.$message.error(response.errMsg);
        }
      });
    },
    clearData() {
      this.isMigrationGroup = false;
      this.targetGroupId = undefined;

      this.groupList = [];
    },
    closeDialog() {
      this.clearData();
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.dialog-content) {
  .delete-group-box {
    font-size: 14px;
    .radio-primary {
      display: inline-block;

      .radio-box {
        margin: 8px 0px;
      }
    }

    .migration-group-box {
      display: flex;
      align-items: center;

      .label-box {
        flex-shrink: 0;
      }
    }
  }
}
</style>